import { forwardRef, useCallback, useEffect, useRef } from 'react';

import { cn } from '@/lib/utils';

const Textarea = forwardRef(({ className, autoResize, onChange, ...props }, ref) => {
  const innerRef = useRef(null);

  const setRef = useCallback(
    (el) => {
      innerRef.current = el;
      if (typeof ref === 'function') ref(el);
      else if (ref) ref.current = el;
    },
    [ref]
  );

  const resize = (el) => {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };

  useEffect(() => {
    if (autoResize) resize(innerRef.current);
  }, [autoResize, props.value]);

  const handleChange = (e) => {
    if (autoResize) resize(e.target);
    onChange?.(e);
  };

  return (
    <textarea
      className={cn(
        'flex min-h-[80px] px-3 py-2 w-full',
        'bg-background border border-input ring-offset-background rounded-md disabled:cursor-not-allowed disabled:opacity-50',
        'font-mono text-base placeholder:text-muted-foreground md:text-sm',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ring',
        autoResize && 'overflow-hidden',
        className
      )}
      ref={setRef}
      onChange={handleChange}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
